import { useCallback, useState } from 'react';
export default function useOnStateChange(initialValue, useData = false) {
  const [value, setValue] = useState(initialValue);
  const onChange = useCallback(({
    value,
    data
  }) => {
    setValue(useData ? data : value);
  }, [setValue, useData]);
  return [value, onChange];
}